// import React from "react";

// const Charts =()=>{
//     return(
//         sdfng
//     )
// }
// export default Charts;

import React from 'react';
import {Chart as ChartJS, CategoryScale, LinearScale, BarElement, LineElement, PointElement, ArcElement, Tooltip, Legend} from 'chart.js';
import { Bar, Line, Pie, Scatter } from 'react-chartjs-2';
import { Typography, Box } from '@mui/material';

ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, ArcElement, Tooltip, Legend);

const data = {
  bar: {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May'],
    datasets: [
      {
        label: 'Revenue',
        data: [12000, 15000, 18000, 20000, 25000],
        backgroundColor: 'rgba(75, 192, 192, 0.6)',
      },
    ],
  },
  line: {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May'],
    datasets: [
      {
        label: 'Profit',
        data: [5000, 7000, 8000, 9000, 11000],
        borderColor: 'rgba(54, 162, 235, 0.6)',
        fill: false,
      },
    ],
  },
  pie: {
    labels: ['Residential', 'Commercial', 'Industrial'],
    datasets: [
      {
        data: [50, 30, 20],
        backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'],
      },
    ],
  },
  
  scatter: {
    datasets: [
      {
        label: 'Scatter Dataset',
        data: [
          { x: -10, y: 0 },
          { x: 0, y: 10 },
          { x: 10, y: 5 },
          { x: 0.5, y: 5.5 },
        ],
        backgroundColor: 'rgba(255, 99, 132, 0.8)',
      },
    ],
  },
  sparkline: {
    labels: ['1', '2', '3', '4', '5', '6'],
    datasets: [
      {
        label: 'Sparkline',
        data: [5, 10, 5, 8, 15, 10],
        borderColor: 'rgba(153, 102, 255, 0.8)',
        borderWidth: 2,
        fill: false,
        tension: 0.4,
      },
    ],
  },
};

const handleClick = (event, elements, chart) => {
    if (elements.length > 0) {
      const datasetIndex = elements[0].datasetIndex;
      const index = elements[0].index;
      const label = chart.data.labels[index];
      const value = chart.data.datasets[datasetIndex].data[index];
      alert(`You clicked on ${label}: ${value}`);
    }
  };

const BarCharts = () => {
    const options = {
        onClick: (event, elements, chart) => handleClick(event, elements, chart),
      };
  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h4" gutterBottom>
        Charts Overview
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap' }}>
        <Box sx={{ width: '300px', margin: '20px' }}>
          <Typography variant="h6" align="center">Bar Chart</Typography>
          <Bar data={data.bar} />
        </Box>

        <Box sx={{ width: '300px', margin: '20px' }}>
          <Typography variant="h6" align="center">Line Chart</Typography>
          <Line data={data.line} />
        </Box>

        <Box sx={{ width: '300px', margin: '20px' }}>
          <Typography variant="h6" align="center">Pie Chart</Typography>
          <Pie data={data.pie} />
        </Box>
    
        <Box sx={{ width: '300px', margin: '20px' }}>
          <Typography variant="h6" align="center">Scatter Chart</Typography>
          <Scatter data={data.scatter} />
        </Box>

        <Box sx={{ width: '300px', margin: '20px' }}>
          <Typography variant="h6" align="center">Sparkline Chart</Typography>
          <Line data={data.sparkline} options={{ plugins: { legend: { display: false } } }} />
        </Box>

        <Box sx={{ width: '300px', margin: '20px' }}>
          <Typography variant="h6" align="center">Click Event Chart</Typography>
          <Bar data={data.bar} options={options} />
        </Box>
      </Box>
    </Box>
  );
};

export default BarCharts;
